import React, { useState } from 'react';

function overlayValueClass(pct) {
  if (pct >= 70) return 'overlay-value overlay-value-green';
  if (pct >= 40) return 'overlay-value overlay-value-amber';
  return 'overlay-value overlay-value-red';
}

export function TickOverlay({ entry, onConfirm, onCancel }) {
  const [conf, setConf] = useState(
    entry.topic_confidence != null ? Math.round(entry.topic_confidence * 100) : 0
  );
  const [noteText, setNoteText] = useState(entry.notes || '');
  const [subtopicNotes, setSubtopicNotes] = useState({});
  const [expandedNote, setExpandedNote] = useState(null);
  const [saving, setSaving] = useState(false);
  const sliderBg = `linear-gradient(to right, var(--blue) 0%, var(--blue) ${conf}%, var(--border) ${conf}%, var(--border) 100%)`;

  const isStudyUnit = entry.entry_kind === 'study_unit' && entry.member_subtopics?.length > 0;

  const handleDone = async () => {
    setSaving(true);
    if (isStudyUnit) {
      await onConfirm(conf / 100, null, subtopicNotes);
    } else {
      await onConfirm(conf / 100, noteText);
    }
  };

  return (
    <div className="overlay-backdrop" onClick={!saving ? onCancel : undefined}>
      <div className="overlay-card" onClick={e => e.stopPropagation()}>
        <div className="overlay-name">{entry.subtopic}</div>
        {entry.subject_area && <div className="overlay-subject">{entry.subject_area}</div>}
        <div className="overlay-label">Confidence</div>
        <input
          type="range" min="0" max="100" step="5"
          value={conf}
          onChange={e => setConf(parseInt(e.target.value))}
          className="overlay-slider"
          style={{ background: sliderBg }}
        />
        <div className="overlay-range"><span>0</span><span>100</span></div>
        <div className={overlayValueClass(conf)}>{conf}%</div>

        {isStudyUnit ? (
          <div className="overlay-subtopic-notes">
            <div className="overlay-notes-label">Notes per topic (optional)</div>
            {entry.member_subtopics.map(s => (
              <div key={s.id} className="overlay-subtopic-row">
                <button
                  className="overlay-subtopic-toggle"
                  onClick={() => setExpandedNote(expandedNote === s.id ? null : s.id)}
                  disabled={saving}
                >
                  <span className="overlay-subtopic-name">{s.name}</span>
                  <span className="overlay-subtopic-chevron">{expandedNote === s.id ? '▲' : '▼'}</span>
                </button>
                {expandedNote === s.id && (
                  <textarea
                    className="overlay-notes overlay-notes-subtopic"
                    rows={2}
                    placeholder="Notes for this topic..."
                    value={subtopicNotes[s.id] ?? (s.notes || '')}
                    onChange={e => setSubtopicNotes(prev => ({ ...prev, [s.id]: e.target.value }))}
                    disabled={saving}
                  />
                )}
              </div>
            ))}
          </div>
        ) : (
          <>
            <div className="overlay-notes-label">Notes (optional)</div>
            <textarea
              className="overlay-notes"
              rows={3}
              placeholder="Quick notes on this topic..."
              value={noteText}
              onChange={e => setNoteText(e.target.value)}
              disabled={saving}
            />
          </>
        )}

        <button
          className="btn-primary-full"
          disabled={saving}
          onClick={handleDone}
          style={{ marginBottom: 8 }}
        >
          {saving ? 'Saving' : 'Done'}
        </button>
        <button className="btn-ghost-full" onClick={onCancel} disabled={saving}>
          Cancel
        </button>
      </div>
    </div>
  );
}

export default TickOverlay;
